<template>
  <div class="assembly-work-order">
    <div v-show="isMain">
      <!-- 面包屑导航 -->
      <div class="white-background list-top-margin" >
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">基础数据</el-breadcrumb-item>
          <el-breadcrumb-item>不良品项</el-breadcrumb-item>
        </el-breadcrumb>
        <list-top :form="form" @search="search" class="list-top-margin" :goodsShow="false"></list-top>
      </div>
      <div class="white-background">
        <el-row class="list-top-margin">
          <el-col :span="18">
            <el-button size="small" type="primary" icon="el-icon-plus" @click="add()">创建不良品项</el-button>
            <el-dropdown class="left-default-margin right-default-margin" @command="handleCommand" trigger="click">
              <el-button type="primary" size="small" plain icon="el-icon-s-operation">批量操作</el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="delete"><i class="el-icon-delete"></i>批量删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-button size="small" type="primary" plain icon="el-icon-download" @click="templateDownload">模板下载</el-button>
            <el-button size="small" type="success" plain icon="el-icon-upload2" @click="importData">导入</el-button>
            <el-button size="small" type="success" plain icon="el-icon-s-promotion" @click="exportExcelNew">导出</el-button>


              <el-upload  ref="workReportImp" name="workReportImp" :action="action()" :on-change="
                  (file, fileList) => {
                  handleChange(file, fileList);
                  }
              "
                :auto-upload="false" :show-file-list="false" accept=".xlsx" v-show="false">

              </el-upload>
            <!-- <el-button type="primary" icon="el-icon-download" plain :size="buttonSize">导入</el-button>
            <el-button type="primary" icon="el-icon-upload2" plain :size="buttonSize">导出</el-button>
            <el-button type="text" icon="el-icon-s-data" @click="showImportLog" :size="buttonSize">查看导入日志</el-button> -->
          </el-col>
          <!-- <el-col :span="6" class="text-align-right">
            <el-popover
              placement="left-start"
              title="列配置"
              width="200"
              trigger="click"
              v-model="popIshow"
              >
              <popover-content :colData="colData" @done="popDone" v-if="popIshow" ></popover-content>
              <el-button slot="reference" icon="el-icon-s-operation" size="small" class="left-default-margin">列配置</el-button>
            </el-popover>
          </el-col> -->
        </el-row>
        <!--列表-->
        <el-table
        size="small"
        ref="tableData"
        :key="uniqueKey"
        :data="listData"
        highlight-current-row
        v-loading="loading"
        max-height="400px"
        stripe border
        element-loading-text="拼命加载中"
        :header-cell-style="_headerStyle"
        style="width: 100%;"
        row-key="_id"
        @selection-change="handleTblSelectionChange">
          <el-table-column type="selection" :reserve-selection="true" width="60">
          </el-table-column>
          <el-table-column prop="no" label="序号" type="index" width="50" v-if="colData[0].istrue" :fixed="colData[0].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column sortable prop="nongoodCode" label="不良品项编号" v-if="colData[1].istrue" :fixed="colData[1].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column  prop="nongoodName" label="不良品项名称" v-if="colData[2].istrue" :fixed="colData[2].isFixed == true ? 'left':null">
          </el-table-column>
          <el-table-column label="操作" width="180" fixed="right" v-if="colData[12].istrue">
            <template slot-scope="scope">
              <el-tooltip content="编辑">
                <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>
              </el-tooltip>
              <el-tooltip content="删除">
                <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogVisible" width="600px" @close="done" :close-on-click-modal="false">
      <create-dialog v-if="dialogVisible" @done="done" :editRow="editRow" :userData="userData" :modelStatus="modelStatus"></create-dialog>
    </el-dialog>
    <ImportLog v-show="!isMain" :menuName="menuName" @goBack="goBack"></ImportLog>
  </div>
</template>

<script>
import { nongoodGetList,batchDelete,nongoodBatchDelete } from '@/api/basicData'
import {nongoodBatchImp} from '@/api/business';
import Pagination from '@/components/Pagination'
import ListTop from './list-top.vue'
import CreateDialog from './create-dialog.vue'
import PopoverContent from '@/components/popover-content.vue'
import ImportLog from '@/components/importLog.vue'
import {exportDataToExcel,transfer} from '@/utils/util';


export default {
  // 注册组件
  components: {
    Pagination,
    ListTop,
    PopoverContent,
    CreateDialog,
    ImportLog,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    var userData = window.localStorage.getItem('userdata')
    if(userData){
      this.userData = JSON.parse(userData)
    }
    this.getColumnDataList()
    this.getdata()
  },
  data() {
    return {
      menuName:{
        first:'基础数据',
        second:'不良品项',
        three:'导入日志',
      },
      buttonSize:'small',
      loading: false, //是显示加载
      isMain:true,
      editForm: {
        deptId: '',
        deptName: '',
        deptNo: '',
        token: localStorage.getItem('logintoken')
      },
      form: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken'),
        updateCondition:'0',
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      colData:[],
      popIshow:false,//控制popover显隐
      uniqueKey:new Date().getTime(),
      dialogVisible:false,
      title:'创建不良品项',
      editRow:{},
      userData:{},
      modelStatus:'',
      tblSelectionList:[]

    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    exportExcelNew(){
      if(this.tblSelectionList == null || this.tblSelectionList.length == 0){
        this.exportData();

        return;
      }
      const header = [
        '不良品项编号',
        '不良品项名称',

      ];

      const filterVal = [
        'nongoodCode',
        'nongoodName',
      ];
      let filterData = JSON.parse(JSON.stringify(this.tblSelectionList));
      let data = filterData.map(v => filterVal.map(j => v[j]));
      exportDataToExcel(data,header,"不良品项清册"+ Date.now());
    },
     /**
     * 监听表格选中项变化事件
     */
     handleTblSelectionChange(val) {
      this.tblSelectionList = val;
      this.isBatchPrint = true;
    },
    exportData(){
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          nongoodCode: this.form.nongoodCode,
          nongoodName: this.form.nongoodName,
        },
        tableName:'不良品项',
        collection:'nongood',
      }

      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/api/exportExcel';
      x.open("POST", url, true);
      x.responseType = 'blob';
      x.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "不良品项清册.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send(JSON.stringify(params));

    },
    handleChange(file, fileList){
        let data = new FormData();

        data.append("file", file.raw);
        data.append("factoryId ", this.userData.factoryId);
        data.append("creater",this.userData.name + "(" + this.userData.account + ")");
        nongoodBatchImp(data).then(res=>{
          this.getdata();

        });

    },
    action(){
      return this.$devEnv.API_ROOT + `/nongood/importData`;
    },
    templateDownload(){
      var x = new XMLHttpRequest();
      var self = this;
      let url = this.$devEnv.API_ROOT + '/nongood/downloadTemplate';
      x.open("GET", url, true);
      x.responseType = 'blob';
      x.onload=function(e) {
          if (x.readyState === x.DONE) {
              if (x.status === 200) {
                  //会创建一个 DOMString，其中包含一个表示参数中给出的对象的URL。这个 URL 的生命周期和创建它的窗口中的 document 绑定。这个新的URL 对象表示指定的 File 对象或 Blob 对象。
                  var url = window.URL.createObjectURL(x.response)
                  var a = document.createElement('a');
                  a.href = url
                  a.download = "不良品项导入模板.xlsx";
                  a.click()
              }else {
                  self.$message({
                      type: 'error',
                      message: '下载失败',
                  });
              }
          }else {
              self.$message({
                  type: 'error',
                  message: '下载失败',
              });
          }
      }
      x.send();
    },
    importData(){
      this.$refs["workReportImp"].$refs['upload-inner'].handleClick();
    },
    add(){
      this.title = '创建不良品项'
      this.modelStatus = 'create'
      this.dialogVisible = true
    },
    getUniqueKey(){
      return new Date().getTime()
    },
    // 查询
    getdata() {
      this.loading = true
      var params = {
        condition: {
          factoryId: this.userData.factoryId,
          nongoodCode: this.form.nongoodCode,
          nongoodName: this.form.nongoodName,
        },
        currentPage: this.pageparm.currentPage,
        pageSize: this.pageparm.pageSize,
      }
      nongoodGetList(params).then(res => {
        if(res.code == 200){
          this.pageparm.total = res.data.total
          this.listData = res.data.list
        }else{
          this.$message.error('查询失败！')
        }
        this.loading = false
      })
      .catch(err => {
        this.loading = false
        this.$message.error(err)
      })
    },
    getColumnDataList(){
     this.colData = [
     { title: "序号", istrue: true, isFixed:false },
	   { title: "单据编号", istrue: true, isFixed:false },
	   { title: "工单数", istrue: true , isFixed:false},
	   { title: "已结束工单", istrue: true , isFixed:false},
	   { title: "计划数", istrue: true , isFixed:false},
	   { title: "完工数", istrue: true, isFixed:false },
	   { title: "生产进度(%)", istrue: true , isFixed:false},
	   { title: "单据进度(%)", istrue: true, isFixed:false },
	   { title: "创建时间", istrue: true, isFixed:false },
	   { title: "更新时间", istrue: true, isFixed:false },
	   { title: "创建人", istrue: true , isFixed:false},
	   { title: "更新人", istrue: true, isFixed:false },
	   { title: "操作", istrue: true,disabled:true },
    ]
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.currentPage = parm.currentPage
      this.pageparm.pageSize = parm.pageSize
      this.getdata()
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.pageparm.pageSize = 10
      this.getdata()
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.title = '编辑不良品项'
      this.modelStatus = 'edit'
      this.editRow = row
      this.dialogVisible = true
    },
    // 删除
    handleDelete(index, row) {
      this.$confirm('确认删除不良品项？删除后不可恢复', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          batchDelete(row._id).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.form)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
          }).catch(err => {
            this.$message.error('删除失败，请稍后再试！')
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 批量操作
    handleCommand(options){
      var selection = this.$refs.tableData.selection
      if(selection.length==0){
        this.$message.warning('请先选择要批量操作的数据')
        return
      }
      if(options == 'delete'){
        this.$confirm('删除后数据无法恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var idList = selection.map(function(item){return item._id})
          var data = {
            idList:idList
          }
          nongoodBatchDelete(idList).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
          }).catch(err => {
              this.$message.error('删除失败，请稍后再试！')
            })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      }
    },
    popDone(options){
      var _this = this
      this.popIshow = false
      if(options.type == 'save'){
        this.colData = JSON.parse(JSON.stringify(options.data))
        this.uniqueKey = this.getUniqueKey()
      }
    },
    done(options){
      this.dialogVisible = false
      if(options && options.type == 'save'){
        this.getdata()
      }
      this.editRow = {}
    },
    showImportLog(){
      this.isMain = false
    },
    goBack(){
      this.isMain = true;
    },
  }
}
</script>

<style scoped>

.userRole {
  width: 100%;
}

.assembly-work-order .el-button+.el-button,
.el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 5px;
}
</style>






// WEBPACK FOOTER //
// src/views/basicData/defectiveProduct/DefectiveProduct.vue